class Configuration {
    userId = "user_KdgcfO6dvfR1ahjxyfPHC";
    serviceId = "service_amg67dr";
    templateId = "template_wtobt7e";
    contactFormTemplateId = "template_m32lopm";
}

export const Config = new Configuration();
